import React from "react";

const ArchiveFilledIcon: React.FC = () => (
    <svg
      width="16"
      height="16"
      className="w-6 h-6"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2129 1.33337H4.78622C3.36622 1.33337 2.21289 2.49337 2.21289 3.90671V13.3C2.21289 14.5 3.07289 15.0067 4.12622 14.4267L7.37956 12.62C7.72622 12.4267 8.28622 12.4267 8.62622 12.62L11.8796 14.4267C12.9329 15.0134 13.7929 14.5067 13.7929 13.3V3.90671C13.7862 2.49337 12.6329 1.33337 11.2129 1.33337ZM10.0062 6.50004C9.35956 6.73337 8.67956 6.85337 7.99956 6.85337C7.31956 6.85337 6.63956 6.73337 5.99289 6.50004C5.73289 6.40671 5.59956 6.12004 5.69289 5.86004C5.79289 5.60004 6.07956 5.46671 6.33956 5.56004C7.41289 5.94671 8.59289 5.94671 9.66622 5.56004C9.92622 5.46671 10.2129 5.60004 10.3062 5.86004C10.3996 6.12004 10.2662 6.40671 10.0062 6.50004Z"
        fill="#12B76A"
      />
    </svg>
  );

export default ArchiveFilledIcon;
